import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';

import { UserProfileComponent } from './user-profile.component';
import { ExternalToolIntegrationModalComponent } from './external-tool-integration-modal/external-tool-integration-modal.component';
import { SharedModule } from '../shared/shared.module';
import { CrmOrganizationsLinkedComponent } from './shared/crm-organizations-linked/crm-organizations-linked.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule.forChild(), SharedModule],
  declarations: [UserProfileComponent, ExternalToolIntegrationModalComponent, CrmOrganizationsLinkedComponent],
  exports: [UserProfileComponent, ExternalToolIntegrationModalComponent],
})
export class UserProfileModule {}
